import { render, staticRenderFns } from "./CommentBase.vue?vue&type=template&id=d68b1564&scoped=true&"
import script from "./CommentBase.vue?vue&type=script&lang=js&"
export * from "./CommentBase.vue?vue&type=script&lang=js&"
import style0 from "./CommentBase.vue?vue&type=style&index=0&id=d68b1564&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d68b1564",
  null
  
)

export default component.exports